/* FC floating widgets manager (R3 micro-edit 6 / 7 / 7b).
   1. Footer dissolve: when the footer enters the viewport, fade the Alex chat
      launcher (#fc-chat) and disable its pointer events so footer links are clickable.
   2. Octane kill: remove the Octane shopping-assistant launcher node if the app
      ScriptTag re-injects it (owner-confirmed NOT Alex). Never touches quiz/checkout. */
(function () {
  var footer =
    document.querySelector('.fc-footer') ||
    document.querySelector('footer.footer') ||
    document.querySelector('footer');

  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var chat = document.getElementById('fc-chat');
      if (chat) chat.classList.toggle('fc-fab-hidden', entries[0].isIntersecting);
    }, { threshold: 0 }).observe(footer);
  }

  // Octane launcher kill (confirmed not Alex). Remove now + if re-injected later.
  function killOctane() {
    ['octane-shopping-assistant-root', 'octane-shopping-assistant-container']
      .forEach(function (id) { var n = document.getElementById(id); if (n) n.remove(); });
  }
  killOctane();
  new MutationObserver(killOctane).observe(document.body, { childList: true, subtree: true });
})();
